package presentation.screens.search

import models.PersonPreview
import models.VideoDetails
import utils.UiAction
import utils.UiState


data class SearchState(
    val query: String = "",
    val identifyQuery: String = "",
    val isLoading: Boolean = false,
    val isNextLoading: Boolean = false,
    val isError: Boolean = false,
    /** null = no search yet; empty = searched with no hits */
    val videos: List<VideoDetails>? = null,
    val persons: List<PersonPreview>? = null,
    val identifyEnabled: Boolean = false,
    val identifyMode: Boolean = false,
) : UiState {
    val hasResults: Boolean
        get() = !videos.isNullOrEmpty() || !persons.isNullOrEmpty()
}

sealed interface SearchMVIAction : UiAction {

    /** Live title search (compact/mobile) — debounce inside VM. */
    data class OnTextChanged(val query: String) : SearchMVIAction

    /** Live identify description (compact/mobile) — debounce inside VM. */
    data class OnIdentifyTextChanged(val query: String) : SearchMVIAction

    /** Update draft title query without searching (desktop/TV). */
    data class OnQueryChanged(val query: String) : SearchMVIAction

    /** Update draft identify query without searching (desktop/TV). */
    data class OnIdentifyQueryChanged(val query: String) : SearchMVIAction

    /** Explicit submit for desktop/TV search. */
    data object SubmitSearch : SearchMVIAction

    data object ToggleIdentifyMode : SearchMVIAction

    data object FetchNextPage : SearchMVIAction
    data object Reload : SearchMVIAction
    data object BackClicked : SearchMVIAction
    data class OnVideoClicked(val id: Int, val isTcShow: Boolean) : SearchMVIAction
    data class OnPersonClicked(val personId: Int) : SearchMVIAction
}
